import { useState, useEffect } from 'react';

import * as api from '../utils/api';
import * as URLS from '../constants/urls';

const usePackageLimitModal = () => {
  const [isPackagesLoading, setPackagesLoading] = useState(false);
  const [packages, setPackages] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);

  const fetchPackages = async () => {
    setPackagesLoading(true);
    try {
      const { data } = await api.get(URLS.GET_ALL_PACKAGE);
      if (data) {
        const currentPage = data.datas.find((p) => p.isUsing);
        const newPackages = data.datas.filter(
          (p) => Number(p.price) > Number(currentPage?.price) || 0
        );
        setPackages(newPackages);
        setCurrentPage(currentPage);
      }
    } catch (error) {
      console.error(error);
    }
    setPackagesLoading(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  return {
    isPackagesLoading,
    packages,
    currentPage,
  };
};

export default usePackageLimitModal;
